import { render, staticRenderFns } from "./ForestBetter.vue?vue&type=template&id=5cb6bd7a&scoped=true"
import script from "./ForestBetter.vue?vue&type=script&lang=js"
export * from "./ForestBetter.vue?vue&type=script&lang=js"
import style0 from "./ForestBetter.vue?vue&type=style&index=0&id=5cb6bd7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb6bd7a",
  null
  
)

export default component.exports